import { FormItemProps, Switch } from 'antd';
import { SwitchChangeEventHandler } from 'antd/es/switch';
import FormItem from 'components/form/FormItem';
import React from 'react';

export interface IFormCheckbox extends FormItemProps {
  disabled?: boolean;
  loading?: boolean;
  onChange?: SwitchChangeEventHandler;
}

export default function FormSwitch({
  name,
  label,
  disabled,
  loading,
  onChange,
  ...props
}: IFormCheckbox) {
  return (
    <FormItem valuePropName="checked" label={label} name={name} {...props}>
      <Switch disabled={disabled} loading={loading} onChange={onChange} />
    </FormItem>
  );
}
